package com.ives.modules;

import haxe.PosInfos;

class ModuleEvent {
	public var points:Array<Float>;
	public var data:Array<Int>;
	public var strings:Array<String>;
	public var workspaceId:Int;
	public var type:String;
	public var editable:Bool;
	public var scalar:Float;
	public var sync:Bool;

	public var external:Bool = false;
	public var origin:String;
	public var posInfos:PosInfos;

	public function new(type:String, ?data:Array<Int>, ?points:Array<Float>, ?strings:Array<String>, ?workspaceId:Int = -1, ?editable:Bool = false, ?scalar:Float, ?sync:Bool = false, ?pos : PosInfos) {
		this.type = type;
		this.data = data;
		this.points = points;
		this.strings = strings;
		this.workspaceId = workspaceId;
		this.editable = editable;
		this.scalar = scalar;
		this.sync = sync;

		this.posInfos = pos;
	}
}
